/*
 * MesYat yazıcı adaptörü
 * 1) Mevcut Android/Flutter köprüsü varsa onu kullanır.
 * 2) Tarayıcı/işletim sistemi yazdırma ekranına düşer.
 * Yazıcı marka bağımlılığını sipariş ekranından ayırır.
 */

function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function normalizePayload(job) {
  const payload =
    job?.payload && typeof job.payload === "object"
      ? job.payload
      : {};

  return {
    queue_id: job?.id,
    ticket_no: job?.fis_no || payload.order_id || "-",
    station: payload.station?.name || job?.istasyon_adi || "Mutfak",
    table: payload.table?.name || job?.masa_no || "Masa",
    waiter: payload.waiter?.name || job?.garson_adi || "-",
    note: payload.note || "",
    created_at: payload.created_at || job?.created_at || new Date().toISOString(),
    paper_width: Number(job?.kagit_genisligi) === 58 ? 58 : 80,
    items: Array.isArray(payload.items) ? payload.items : [],
  };
}

function ticketHtml(job) {
  const data = normalizePayload(job);
  const width = data.paper_width === 58 ? "54mm" : "76mm";
  const rows = data.items
    .map(
      (item) => `
        <div class="item">
          <strong>${escapeHtml(item.quantity || 1)} × ${escapeHtml(
            item.display_title || item.title || "Ürün"
          )}</strong>
          ${item.note ? `<div class="note">Not: ${escapeHtml(item.note)}</div>` : ""}
        </div>`
    )
    .join("");

  return `<!doctype html>
  <html lang="tr">
    <head>
      <meta charset="utf-8" />
      <title>MesYat Mutfak Fişi</title>
      <style>
        @page { size: ${data.paper_width}mm auto; margin: 2mm; }
        * { box-sizing: border-box; }
        body { width: ${width}; margin: 0 auto; color: #000; font-family: Arial, sans-serif; font-size: 13px; }
        h1 { margin: 0 0 4px; text-align: center; font-size: 20px; }
        .meta { border-top: 1px dashed #000; border-bottom: 1px dashed #000; padding: 6px 0; line-height: 1.45; }
        .item { padding: 7px 0; border-bottom: 1px dashed #000; font-size: 15px; }
        .note { margin-top: 3px; font-size: 12px; font-weight: 700; }
        .footer { padding-top: 6px; text-align: center; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>${escapeHtml(data.station)}</h1>
      <div class="meta">
        <div><strong>${escapeHtml(data.table)}</strong></div>
        <div>Garson: ${escapeHtml(data.waiter)}</div>
        <div>Fiş: ${escapeHtml(data.ticket_no)}</div>
        <div>${escapeHtml(new Date(data.created_at).toLocaleString("tr-TR"))}</div>
      </div>
      ${rows}
      ${data.note ? `<div class="item"><strong>Sipariş Notu:</strong><br>${escapeHtml(data.note)}</div>` : ""}
      <div class="footer">MesYat Dijital Garson & Adisyon</div>
      <script>window.onload = function () { window.print(); };</script>
    </body>
  </html>`;
}

export function hasMesYatNativePrinter() {
  return Boolean(
    window?.MesYatPrinter?.printTicket ||
      window?.MesYatPrinter?.postMessage
  );
}

export async function printKitchenTicket(job) {
  const payload = normalizePayload(job);

  if (typeof window?.MesYatPrinter?.printTicket === "function") {
    await window.MesYatPrinter.printTicket(payload);
    return { mode: "native", ok: true };
  }

  if (typeof window?.MesYatPrinter?.postMessage === "function") {
    window.MesYatPrinter.postMessage(
      JSON.stringify({ action: "print_ticket", payload })
    );
    return { mode: "native_channel", ok: true };
  }

  const printWindow = window.open("", "_blank", "width=480,height=760");
  if (!printWindow) {
    throw new Error("Yazdırma penceresi engellendi. Tarayıcıda açılır pencerelere izin verin.");
  }

  printWindow.document.open();
  printWindow.document.write(ticketHtml(job));
  printWindow.document.close();
  return { mode: "browser", ok: true };
}

export default {
  hasMesYatNativePrinter,
  printKitchenTicket,
};
